import React from 'react'
import CrudDinamicoFormPageContainer from './CrudDinamicoFormPageContainer'

export class CrudDinamicoFormPage extends React.Component {
  render() {
    return <CrudDinamicoFormPageContainer {...this.props} />
  }
}
